/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import useFetcher from "../../../hooks/useFetcher";
import { LabSelect } from "../../course/select";
import { CustomLabel } from "../../../ui/labels";
import { InputText } from "../../../ui/inputs";
import { ButtonPrimary } from "../../../ui/buttons";

const MotivoNoAvanzaFormModal = ({ toggle, isOpen, handleMotivoNoAvanza, info }) => {
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined);
  const motivos = categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.motivos;
  const [motivoValue, setMotivoValue] = useState("");
  const [subMotivoValue, setSubMotivoValue] = useState("");
  const [otroSubMotivoValue, setOtroSubMotivoValue] = useState("");

  const motivosOptions = motivos ? Array.from(new Set(motivos.map((e) => e.motivo))).map((motivo) => ({ label: motivo, value: motivo })) : [];

  const submotivosOptions = motivos
    ? motivos
        .map((e) => {
          return { label: e.subMotivo, value: e.id, motivo: e.motivo };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const submotivosOptionsForFiltered = motivoValue ? submotivosOptions.filter((submotivo) => submotivo.motivo === motivoValue.value) : submotivosOptions;

  function getFunctionToFilter(filter, selected) {
    if (filter === "motivo") {
      setMotivoValue(selected);
      if (selected === null) setSubMotivoValue(null);
    }
    if (filter === "submotivo") {
      setSubMotivoValue(selected);
      if (!motivoValue) setMotivoValue({ label: selected.motivo, value: selected.motivo });
    }
  }

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const motivoNoAvanza = {
    motivo: subMotivoValue ? subMotivoValue.value : "",
    motivoOtro: otroSubMotivoValue,
  };

  const handleContinuar = () => {
    handleMotivoNoAvanza(motivoNoAvanza);
    toggle();
  };

  useEffect(() => {
    if (info) {
      const currentMotivo = submotivosOptionsForFiltered.find((e) => e.value === info.motivo);
      setSubMotivoValue(currentMotivo);
      if (currentMotivo) setMotivoValue({ label: currentMotivo.motivo, value: currentMotivo.motivo });
      if (info.motivoOtro) setOtroSubMotivoValue(info.motivoOtro);
    }
  }, [info, motivos]);

  return (
    <div>
      <Modal isOpen={isOpen} centered style={{ fontFamily: "Nunito" }}>
        <ModalHeader toggle={toggle} className="border-0 pb-0" style={{ background: " #f8f8f8" }} />
        <ModalBody className="pt-1" style={{ alignItems: "flex-start !important", background: " #f8f8f8" }}>
          <h4>Indicar motivo de no avance</h4>
          <div className="col-sm-9">
            <div className="form-group">
              <CustomLabel htmlFor="motivo" className="pt-0 w-100">
                Motivo
                <LabSelect
                  id="motivo"
                  name="motivo"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={motivoValue}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoadingCategoies}
                  isDisabled={isLoadingCategoies}
                  options={motivosOptions}
                />
              </CustomLabel>
            </div>
          </div>
          <div className="col-sm-9">
            <div className="form-group">
              <CustomLabel htmlFor="submotivo" className="pt-0 w-100">
                Submotivo
                <LabSelect
                  id="submotivo"
                  name="submotivo"
                  className="w-100"
                  onChange={handleReactSelectChange}
                  value={subMotivoValue}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoadingCategoies}
                  isDisabled={isLoadingCategoies}
                  options={submotivosOptionsForFiltered}
                />
              </CustomLabel>
            </div>
          </div>

          {subMotivoValue && subMotivoValue.value === 15 && (
            <div className="col-sm-9">
              <div className="mb-3">
                <CustomLabel htmlFor="otro" className="pt-0 w-100">
                  Otro submotivo
                  <InputText
                    className="w-100"
                    type="text"
                    name="otro"
                    //   placeholder="otro"
                    onChange={(e) => setOtroSubMotivoValue(e.target.value)}
                    value={otroSubMotivoValue}
                  />
                </CustomLabel>
              </div>
            </div>
          )}
        </ModalBody>
        <ModalFooter style={{ background: "#f8f8f8", borderTop: "none" }}>
          <div className=" mt-3 mb-0 d-flex justify-content-end">
            <Button color="btn-secondary mr-2" onClick={toggle}>
              Cancelar
            </Button>
            <ButtonPrimary type="button" onClick={handleContinuar}>
              Continuar
            </ButtonPrimary>
          </div>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default MotivoNoAvanzaFormModal;
